var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AfterViewInit, ElementRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { DriveState } from '../state/drive-state';
import { Observable } from 'rxjs';
var ToggleSelectedClassDirective = /** @class */ (function () {
    function ToggleSelectedClassDirective(el) {
        this.el = el;
    }
    ToggleSelectedClassDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.selectedEntryIds.subscribe(function (ids) {
            var els = _this.el.nativeElement.querySelectorAll('.drive-entry');
            if (!els.length)
                return;
            Array.from(els).forEach(function (el) {
                var selected = ids.indexOf(parseInt(el.dataset.id, 10)) > -1;
                if (selected) {
                    el.classList.add('selected');
                }
                else {
                    el.classList.remove('selected');
                }
            });
        });
    };
    __decorate([
        Select(DriveState.selectedEntryIds),
        __metadata("design:type", Observable)
    ], ToggleSelectedClassDirective.prototype, "selectedEntryIds", void 0);
    return ToggleSelectedClassDirective;
}());
export { ToggleSelectedClassDirective };
